import Cookie from "react-cookies";

export const authKey = 'token';

export function setLocalStorage(key: string, value: string) {
  if (typeof document !== "undefined") {
    localStorage.setItem(key, value);
  }
}

export function getLocalStorage(key: string) {
  if (typeof document !== "undefined") {
    return localStorage.getItem(key);
  }
  return "";
}

export function removeLocalStorage(key: string) {
  if (typeof document !== "undefined") {
    return localStorage.removeItem(key);
  }
  return "";
}

export const saveCookie = (value: string) => {
  Cookie.save(authKey, value, {
    domain: process.env.APP_ENV === "dev" ? "localhost" : "envhome.com",
  });
};
